import { Component, effect, input, OnDestroy, OnInit, output } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { NgStyle } from '@angular/common';
import { Subscription } from 'rxjs';
import { AixButtonComponent, BUTTON_TYPE } from '../aix-button/aix-button.component';
import { AixDataTestingDirective } from '../../directives/data-testing/data-testing.directive';
import { AixInputComponent } from '../aix-input/aix-input.component';
import { AixCheckboxComponent } from '../aix-checkbox/aix-checkbox.component';
import { AixTextareaComponent } from '../aix-textarea/aix-textarea.component';
import { CustomTemplate } from '@trade-platform/ui-shared';
import { AixRichTextComponent } from '../aix-rich-text/aix-rich-text.component';

@Component({
    selector: 'aix-assign-box-template',
    templateUrl: 'assign-box-template.component.html',
    styleUrls: ['./assign-box-template.component.scss'],
    standalone: true,
    imports: [
        NgStyle,
        FormsModule,
        ReactiveFormsModule,
        AixButtonComponent,
        AixDataTestingDirective,
        AixInputComponent,
        AixCheckboxComponent,
        AixTextareaComponent,
        AixRichTextComponent
    ]
})
export class AixAssignBoxTemplateComponent implements OnInit, OnDestroy {
    onHide = output();
    onSave = output<CustomTemplate>();

    editRecord = input<CustomTemplate>();
    checkboxDescription = input<string>('');
    useRichText = input<boolean>(true);

    templateForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        subject: new UntypedFormControl('', [Validators.required]),
        body: new UntypedFormControl('', [Validators.required]),
        isPrimary: new UntypedFormControl(false)
    });

    isOpen = false;
    isEditing = false;
    styles: any = { height: '0px' };

    cancelButtonType = BUTTON_TYPE.link;

    subscriptions: Subscription[] = [];

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        effect(() => {
            if (this.editRecord()) {
                this.templateForm.patchValue({
                    ...this.editRecord()
                });
            }
        });
    }

    ngOnInit() {
        this.styles = { height: 'auto', opacity: 1, overflow: 'visible' };
    }

    saveTemplate() {
        const template = {
            id: this.editRecord()?.id,
            name: this.templateForm.get('name')?.value as UntypedFormControl,
            subject: this.templateForm.get('subject')?.value as UntypedFormControl,
            body: this.templateForm.get('body')?.value as UntypedFormControl,
            isPrimary: this.templateForm.get('isPrimary')?.value as UntypedFormControl
        };

        this.onSave.emit(template as unknown as CustomTemplate);

        this.hide();
    }

    hide() {
        this.onHide.emit();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
